import React from 'react';

var accountTitle_AccountNumber_Regex = /^[0-9a-zA-Z -]+$/;
function numberWithCommas(amount: any) {
  if (amount === 'NaN' || amount === NaN || amount === '' || amount === undefined) {
    return ''
  } else {
    return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  }
}
function sortAMCS(data) {
  let sortedData = data.sort(function (a, b) {
    let x = a.name.toLowerCase();
    let y = b.name.toLowerCase();
    if (x > y) { return 1; }
    if (x < y) { return -1; }
    return 0;
  });
  return sortedData;
}
function toProperCase(str) {
  return str.replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
}

function isNumber(value) {
  if (value == NaN || value == 'NaN' || value == undefined || value == 'undefined' || value == '') {
    value = '0';
  }
  return value;
}

 function isDateValid(date:any){
  if(date=='Invalid date'){
    date='';
  }
 return date;
 }

 export const arrFundManagement = [
  {
    value: "main_fund",
    label: "Main Fund",
  },
  {
    value: "sub_fund",
    label: "Sub Fund",
  },
  {
    value: "plan",
    label: "Plan",
  },
];
 
export const trusteeArr = [
  {
    label: "DCCL",
    value: "DCCL",
  },
  {
    label: "CDC",
    value: "CDC",
  },
];
export const VPFType = ["Equity", "Debt", "Money Market"];
 
export const showVPSFundLogic = {
  "Provident Fund": true,
  "Voluntary Pension Fund": true,
  "Debt Fund": true,
  "Stock Fund": true,
  "Money Market Fund": true,
};
 
export const typeRatioSystematic = [
  {
    label: "Conservative",
    ratio: {
      "Stock Fund": "10-25%",
      "Debt Fund": "40-60%",
      "Money Market Fund": "30-50%",
    },
  },
  {
    label: "Balanced",
    ratio: {
      "Stock Fund": "35-50%",
      "Debt Fund": "20-40%",
      "Money Market Fund": "20-35%",
    },
  },
  {
    label: "Aggressive",
    ratio: {
      "Stock Fund": "65-80%",
      "Debt Fund": "10-25%",
      "Money Market Fund": "10-25%",
    },
  },
];
 
export const systematicVPSType = [
  "Conservative",
  "Balanced",
  "Aggressive",
  "Customized Allocation Scheme",
];
 
export const unitholderCategoryType = ["Unitholder", "Participant"];

export { 
  numberWithCommas, 
  toProperCase, 
  isNumber,
  sortAMCS,
  isDateValid ,
  accountTitle_AccountNumber_Regex,
 };